import React, {PropsWithChildren, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import OfflineModal from '../../components/presentationView/parts/components/OfflineModal';
import {usePresentationParams} from '../../hooks/usePresentationParams';
import {useTabLock} from '../../hooks/useTabLock';
import {setRoomInfoModalAction} from '../../store/actions/roomProtection.actions';
import {roomInfoModalSelector} from '../../store/selectors/roomProtection.selector';
import RoomInfoModal from './room/lobby/modals/RoomInfoModal';

function PresLoaderWrapper({children}: PropsWithChildren<unknown>): JSX.Element {
    const dispatch = useDispatch();
    const {presentationId} = usePresentationParams();
    const infoModal = useSelector(roomInfoModalSelector);
    const {isTaken: isPresTaken} = useTabLock('pres', presentationId);

    useEffect(() => {
        if (isPresTaken === true) {
            dispatch(setRoomInfoModalAction(true, 'lobby.modals.presAlreadyOpen', 'lobby.modals.presAlreadyOpenDesc'));
        } else if (isPresTaken === false) {
            dispatch(setRoomInfoModalAction(false, '', ''));
        }
    }, [dispatch, isPresTaken]);

    return (
        <>
            {isPresTaken === false && children}
            {infoModal.open && <RoomInfoModal />}
            <OfflineModal />
        </>
    );
}

export default PresLoaderWrapper;
